export enum ExcelColumns {
  date = 'Date',
  bidStage = 'Bids Stage',
  par = 'Par ($M)',
  issuer = 'Issuer',
  issueDescription = 'Issue Description',
  state = 'State',
  bidSubmission = 'Bid Submission',
  enhancement = 'Enhancement',
  taxStatus = 'Tax Status',
  type = 'Type',
  rop = 'ROP',
  esg = 'ESG',
  sector = 'Sector',
  purpose = 'Purpose',
  structure = 'Structure',
  leadManager = 'Lead Manager',
  erp = 'ERP',
  sourceOfRepayment = 'Source of Repayment',
  bankQualified = 'Bank Qualified',
  issueType = 'Issue Type',
  firstCallDate = 'First Call Date',
  firstCouponDate = 'First Coupon Date',
  datedDate = 'Dated Date',
  dealStatus = 'Deal Status',
  ratings = 'Ratings',
  offeringType = 'Offering Type',
  SaleDate = 'Sale Date',
  SaleTime = 'Sale Time',
  LocalTime = 'Local Time',
  parityPlus = 'Parity+'
}
